const deptId = '101'
const baseUrl = 'https://www.sufcreative.com/meetingsignserv'
export {
    deptId,
    baseUrl
}